// extracted by mini-css-extract-plugin
export default {"investmentInfo":"styles_investmentInfo__r61Lx"};